import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import { LabsPreparationConfig } from "@widgets/LabsPreparation/LabsPreparation.skeleton"
import { memberListConfig } from "@widgets/MemberList/MemberList.skeleton"

const buttonConfig = [
    {
        classes: "marginTop-16",
        columns: [
            {
                span: 4,
                height: "40px",
            },
            {
                span: 4,
                height: "40px",
            },
        ],
    },
]

export const SlotSelectionConfig = [
    {
        span: 14,
        height: "74px",
        classes: "marginTop-16",
    },
    {
        classes: "marginTop-16",
        columns: [
            {
                span: 2,
                height: "44px",
            },
            {
                span: 2,
                height: "44px",
            },
            {
                span: 2,
                height: "44px",
            },
            {
                span: 2,
                height: "44px",
            },
            {
                span: 2,
                height: "44px",
            },
            {
                span: 2,
                height: "44px",
            },
            {
                span: 2,
                height: "44px",
            },
        ],
    },
    {
        classes: "marginTop-16 justifyBetween flexWrap flex",
        columns: [
            {
                span: 6,
                height: "37px",
            },
            {
                span: 6,
                height: "37px",
            },
        ],
    },
    { span: 14, height: "1px", classes: "marginTop-8" },
    {
        classes: "marginTop-16 justifyBetween flexWrap flex",
        columns: [
            {
                span: 6,
                height: "37px",
            },
            {
                span: 6,
                height: "37px",
            },
        ],
    },
    { span: 14, height: "1px", classes: "marginTop-8" },
    {
        classes: "marginTop-16 justifyBetween flexWrap flex",
        columns: [
            {
                span: 6,
                height: "37px",
            },
            {
                span: 6,
                height: "37px",
            },
        ],
    },
    { span: 14, height: "1px", classes: "marginTop-8" },
    {
        classes: "marginTop-16 justifyBetween flexWrap flex",
        columns: [
            {
                span: 6,
                height: "37px",
            },
            {
                span: 6,
                height: "37px",
            },
        ],
    },
    { span: 14, height: "1px", classes: "marginTop-8" },
    {
        classes: "marginTop-16 justifyBetween flexWrap flex",
        columns: [
            {
                span: 6,
                height: "37px",
            },
            {
                span: 6,
                height: "37px",
            },
        ],
    },
    { span: 14, height: "1px", classes: "marginTop-8" },
    {
        classes: "marginTop-16 justifyBetween flexWrap flex",
        columns: [
            {
                span: 6,
                height: "37px",
            },
            {
                span: 6,
                height: "37px",
            },
        ],
    },
    { span: 14, height: "1px", classes: "marginTop-8" },
    {
        classes: "marginTop-16 justifyBetween flexWrap flex",
        columns: [
            {
                span: 6,
                height: "37px",
            },
            {
                span: 6,
                height: "37px",
            },
        ],
    },
]

const PatientSlotSkeleton = () => {
    return (
        <div className="page-container">
            <div className="flex">
                <div className="flexColumn">
                    <Skeleton config={buttonConfig} />
                    <div className="marginTop-8">
                        <Skeleton config={LabsPreparationConfig} />
                    </div>
                    <Skeleton config={SlotSelectionConfig} />
                </div>
                <div className="flexColumn">
                    <Skeleton config={memberListConfig(5)} />
                    <Skeleton config={[{ span: 6, height: "40px", classes: "marginTop-16" }]} />
                </div>
            </div>
        </div>
    )
}

export default PatientSlotSkeleton
